import { makeStyles } from '@mui/styles';
import React from 'react';

import DataGrid from '#app/Component/DataGrid';
import { transformObjectToDataGridRowsArray } from '#app/Util/DataGridDataTransformer';
import { formatNumberToEurCurrency } from '#app/Util/NumberTool';
import { Filters } from '#app/View/Statistic/Order/StatisticOrder';
import useStatisticOrderTotal from '#app/View/Statistic/Order/hooks/useStatisticOrderTotal';
import { TaxTypeId, TaxTypeTranslation } from '#app/typings/orderDocument';

type Props = {
  filters: Filters;
};

const ListTotals: React.FC<Props> = ({ filters }) => {
  const classes = useStyles();
  const { totalPrice, loading } = useStatisticOrderTotal(filters);

  return (
    <DataGrid
      className={classes.container}
      loading={loading}
      hideFooter
      columns={[
        ...(Object.keys(TaxTypeTranslation) as TaxTypeId[])
          .filter((taxTypeId) => totalPrice[taxTypeId] > 0)
          .map((taxTypeId) => ({
            field: taxTypeId,
            headerName: `TVA ${TaxTypeTranslation[taxTypeId]}`,
            flex: 1,
            valueGetter: (value: number) => formatNumberToEurCurrency(value),
          })),
        {
          field: 'totalHT',
          headerName: 'Total HT',
          flex: 1,
          valueGetter: (value) => formatNumberToEurCurrency(value),
        },
        {
          field: 'totalTTC',
          headerName: 'Total TTC',
          flex: 1,
          valueGetter: (value) => formatNumberToEurCurrency(value),
        },
      ]}
      rows={transformObjectToDataGridRowsArray([totalPrice])}
    />
  );
};

const useStyles = makeStyles({
  container: {
    marginTop: 20,
    marginBottom: 20,
  },
});

export default ListTotals;
